import axios from "axios";
import { api_urls, recharge_urls } from "../api-urls";
import { encode as btoa } from 'base-64';
import { toaster } from "../../services/toast-service";
import { access_token, razorpay_live_key } from "../constants";

if (typeof global.btoa === 'undefined') global.btoa = btoa;

export const getAPI = async ({ key = 'Web', url, project = 'Bharat-Darshan' }) => {
    const token = localStorage.getItem(access_token);
    const milanSathiToken = localStorage.getItem('token');

    let baseURL = '';
    switch (key) {
        case 'Web':
            baseURL = api_urls;
            break;
        case 'Recharge':
            baseURL = recharge_urls;
            break;
        default:
            baseURL = api_urls;
    }

    const response = await axios.get(baseURL + url, { headers: { Authorization: 'Bearer ' + (project === 'Bharat-Darshan' ? token : milanSathiToken) } });
    return response;
}

export const postAPI = async ({ key = 'Web', url, payload, project = 'Bharat-Darshan' }) => {
    const token = localStorage.getItem(access_token);
    const milanSathiToken = localStorage.getItem('token');

    let baseURL = '';
    switch (key) {
        case 'Web':
            baseURL = api_urls;
            break;
        case 'Recharge':
            baseURL = recharge_urls;
            break;
        default:
            baseURL = api_urls;
    }

    const response = await axios.post(baseURL + url, payload, { headers: { Authorization: 'Bearer ' + (project === 'Bharat-Darshan' ? token : milanSathiToken) } });
    return response;
}

export const putAPI = async ({ key = 'Web', url, payload, project = 'Bharat-Darshan' }) => {
    const token = localStorage.getItem(access_token);
    const milanSathiToken = localStorage.getItem('token');

    let baseURL = '';
    switch (key) {
        case 'Web':
            baseURL = api_urls;
            break;
        case 'Recharge':
            baseURL = recharge_urls;
            break;
        default:
            baseURL = api_urls;
    }

    // const response = await axios.put(baseURL + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    const response = await axios.put(baseURL + url, payload, { headers: { Authorization: 'Bearer ' + (project === 'Bharat-Darshan' ? token : milanSathiToken) } });
    return response;
}

export const deleteAPI = async ({ key = 'Web', url }) => {
    const token = localStorage.getItem(access_token);

    let baseURL = '';
    switch (key) {
        case 'Web':
            baseURL = api_urls;
            break;
        case 'Recharge':
            baseURL = recharge_urls;
            break;
        default:
            baseURL = api_urls;
    }

    const response = await axios.delete(baseURL + url, { headers: { Authorization: 'Bearer ' + token } });
    return response;
}

export const kundliRequest = async (url, payload) => {
    const credentials = `${630051}:${'861bba6a92587a326a9b11ab9dfb9b7ca3492fab'}`;
    const token = btoa(credentials);

    const response = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token } })
    return response?.data;
};

export const AstrologyAPIRequest = async (url, payload) => {
    const credentials = `${630051}:${'861bba6a92587a326a9b11ab9dfb9b7ca3492fab'}`;
    const token = btoa(credentials);

    const response = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token } })
    return response?.data;
};

// Auto-submit a hidden POST form to the gateway URL
function submitFormToGateway(actionUrl, fields) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;
    Object.entries(fields || {}).forEach(([k, v]) => {
        if (k === 'paymentUrl') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = k;
        input.value = v == null ? '' : String(v);
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}

// Unified PayU / CCAvenue / UPI gateway initiator. Mirrors marketplace flow.
// Persists booking payload to localStorage so /payment-success can finalize after redirect.
export const payuPayment = async ({ amount = 0, service, bookingType, bookingData, name = '', email = '', contact = '' }) => {
    const token = localStorage.getItem(access_token) || localStorage.getItem('token');
    try {
        const res = await axios.post(api_urls + 'api/app/create-payment-order', {
            amount, service, buyerName: name, email, phone: contact,
        }, { headers: { Authorization: 'Bearer ' + token } });
        const data = res?.data;

        if (!data?.success) {
            toaster?.error({ text: data?.message || 'Payment initiation failed.' });
            return { status: false };
        }

        const txnid = data?.payuData?.txnid || data?.ccavenueData?.orderId || data?.clientTxnId || data?.data?.id || ('TXN' + Date.now());
        try {
            const pending = { bookingType, bookingData, amount, txnid, gateway: data?.gateway, service, ts: Date.now() };
            localStorage.setItem('bd_pending_booking', JSON.stringify(pending));
            localStorage.setItem('bd_pending_booking_' + txnid, JSON.stringify(pending));
        } catch (_) {}

        if (data?.gateway === 'payu' && data?.payuData) {
            submitFormToGateway(data.payuData.paymentUrl || 'https://secure.payu.in/_payment', data.payuData);
            return { status: true, redirecting: true };
        }
        if (data?.gateway === 'ccavenue' && data?.ccavenueData) {
            submitFormToGateway(data.ccavenueData.paymentUrl, {
                encRequest: data.ccavenueData.encRequest,
                access_code: data.ccavenueData.accessCode,
            });
            return { status: true, redirecting: true };
        }
        if ((data?.gateway === 'upigateway' || data?.gateway === 'instamojo') && data?.paymentUrl) {
            window.location.href = data.paymentUrl;
            return { status: true, redirecting: true };
        }
        toaster?.error({ text: 'No supported payment gateway is available right now.' });
        return { status: false };
    } catch (e) {
        toaster?.error({ text: e?.response?.data?.message || 'Payment could not be initiated.' });
        return { status: false };
    }
};

export const razorpayPayment = async ({ amount = 0, name = '', email = '', contact = '' }) => {

    const { data } = await postAPI({ url: 'api/app/customer/create_razorpay_order', payload: { amount } });
    console.log("Order Response :::", data);

    if (!data?.status) {
        toaster?.error({ text: 'Payment Failed.' });
        return;
    }

    let options = {
        key: data?.key_id || razorpay_live_key,
        name,
        currency: 'INR',
        amount: data?.data?.amount,
        order_id: data?.data?.id,
        prefill: { name, email, contact },
        theme: { color: '#E15602' },
        description: `Your Amount : ${data?.data?.amount}`,
        image: 'https://www.pngall.com/wp-content/uploads/5/User-Profile-PNG-Image.png',
    };

    console.log("Razor Pay Option ::: ", options);

    return new Promise((resolve, reject) => {
        options.handler = function (response) {
            console.log('Handler Response ::: ', response);
            resolve({ status: true, message: 'Payment was successful.', result: response });
        };

        options.modal = {
            ondismiss: function () {
                console.log("Payment Dismissed !!! ");
                resolve({ status: false, message: 'Payment was dismissed by the user.', result: null });
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.on('payment.failed', function (response) {
            console.log("Payment Failed !!! ", response?.error);
            reject({ status: false, message: response?.error?.description, result: response?.error });
        });
        razorpay.open();
    });
};

export const paypalPayment = async ({ amount = 0, name = '', email = '', contact = '' }) => {
    try {
        const { data } = await postAPI({ url: 'api/paypal/pay', payload: { amount, currency: 'USD' } });
        console.log("PayPal Create Order Response :::", data);

        if (!data?.success || !data?.orderID) {
            toaster?.error({ text: 'Payment creation failed.' });
            return;
        }

        // const orderID = data.id;
        const orderID = data?.orderID;

        return new Promise((resolve, reject) => {
            if (!window.paypal) {
                reject({ status: false, message: 'PayPal SDK not loaded' });
                return;
            }

            const container = document.getElementById('paypal-button-container');
            if (!container) {
                toaster?.error({ text: 'PayPal container not found.' });
                reject({ status: false, message: 'PayPal container not found' });
                return;
            }

            window?.paypal?.Buttons({
                createOrder: () => orderID,
                onApprove: (data, actions) => {
                    return actions.order.capture().then((response) => {
                        console.log('Handler Response - Payment Success ::: ', response);
                        resolve({
                            status: true, message: 'Payment was successful.', result: {
                                paypal_order_id: response?.id,
                                paymentId: response?.id,
                                status: response?.status,
                                amount: response?.purchase_units?.[0]?.amount?.value,
                                currency: response?.purchase_units?.[0]?.amount?.currency_code,
                                payer_name: ` ${response?.payer?.name?.given_name} ${response?.payer?.name?.surname}`,
                                payer_email: response?.payer?.email_address,
                                payer_id: response?.payer?.payer_id,
                                payment_time: response?.create_time,
                                name,
                                email,
                                contact
                            }
                        });
                    });
                },
                onCancel: () => {
                    console.log("Payment Dismissed !!! ");
                    resolve({ status: false, message: 'Payment was dismissed by the user.', result: null });
                },
                onError: (error) => {
                    console.log("Payment Failed !!! ", error);
                    // reject({ status: false, result: error });
                    if (error.message?.includes("Window closed before response")) {
                        toaster?.error({ text: "Payment dismissed before completion." });
                    } else {
                        toaster?.error({ text: "Something went wrong during payment." });
                    }
                    reject({ status: false, result: error });
                },
            }).render('#paypal-button-container');

        });
    } catch (err) {
        console.error("paypalPayment top-level error", err);
        toaster?.error({ text: "Something went wrong while initiating PayPal payment." });
        return Promise.reject({ status: false, message: "API call failed", error: err });
    }
};